module.exports = __webpack_public_path__ + "img/100.00b42012.png";